import {useEffect} from 'react';

export function useEditorPrefetchTabsMobileModules(): void {
  useEffect((): void => {
    void prefetchTabsModules();
  }, []);

  const prefetchTabsModules = async (): Promise<void> => {
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-font-size-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-font-style-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-text-item-font-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-number-of-tabs-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-layout-fill-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-alignment-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-text-outline-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-background-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-tab-item-separator-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-line-height-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-letter-spacing-panel');
  };
}
